import React, { Component, useState } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { withStyles, useTheme } from '@material-ui/core/styles';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DayStepper from '../day-stepper/day-stepper';
import moment from 'moment';

function ArticleListDialog(props) {
  const { classes, onClose, printReport } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [reportDate, setReportDate] = useState(null);

  const printButton = (
    <Button
      color="primary"
      className={classes.button}
      onClick={() => {
        printReport(props.reports[0].reports[selectedIndex], reportDate);
      }}
    >
      Drucken
    </Button>
  );

  const backButton = (
    <Button
      color="primary"
      className={classes.button}
      onClick={onClose}
    >
      Zurück
    </Button>
  );

  if (!props.reports || !props.reports[0]) {
    return null;
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      classes={{ paper: 'printDialog' }}
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Berichte</DialogTitle>

      <DialogContent>
        <DayStepper
          value={reportDate || moment()}
          onChange={date => setReportDate(moment(date).startOf('day'))}
        />
        <List component="nav">
          {props.reports[0].reports.map((report, index) => (
            <ListItem
              button
              selected={selectedIndex === index}
              onClick={(event, i) => setSelectedIndex(index)}
            >
              <ListItemText primary={report.name} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        {selectedIndex == null ? null : printButton}
        {backButton}
      </DialogActions>
    </Dialog>
  );
}


const styles = theme => ({
});


ArticleListDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  reports: PropTypes.array.isRequired,
  printReport: PropTypes.func.isRequired,
  isEPosPrinterEnabled: PropTypes.bool.isRequired,
};

ArticleListDialog.defaultProps = {
};


export default withStyles(styles)(ArticleListDialog);

